import { useEffect, useRef } from "react";
import { useAppDispatch } from "hooks/redux";
import { emailBuilderCloseBlockSettings } from "redux/actions/emailBuilder/emailBuilder";
import { editorReduxStore } from "../../domain/store";
import { selectSelection } from "../../domain/selectors";
import { selectionEntityId } from "../../domain/selection/entity-id";
import { selectionHasRightPanelTarget } from "../../domain/selection/right-panel";

export function useEmailBuilderClientShellSelectionSettingsSync(
  mode: "design" | "preview",
): void {
  const dispatch = useAppDispatch();
  const previousEntityIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (mode !== "design") {
      return;
    }

    function syncFromEditorSelection(): void {
      const selection = selectSelection(editorReduxStore.getState().editor);
      const entityId = selectionEntityId(selection);

      if (previousEntityIdRef.current === entityId) {
        return;
      }
      previousEntityIdRef.current = entityId;

      if (!selectionHasRightPanelTarget(selection)) {
        dispatch(emailBuilderCloseBlockSettings());
      }
    }

    syncFromEditorSelection();
    return editorReduxStore.subscribe(syncFromEditorSelection);
  }, [dispatch, mode]);
}
